import React from 'react';

const Loader = () => {
  return (
    <>
    <div id="loader" >
      <div className="loader-item" style={{textAlign: '-webkit-center'}}> <img src="img/logo_intro.svg" width="30%" alt="Fleur de Sel Restaurant Luxembourg" />
        <div className="spinner">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Loader;